function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#de2910"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "M10 6l1.04 3.08 3.46-.02-2.81 1.88L12.78 14 10 12.08 7.22 14l1.09-3.06L5.5 9.06l3.46.02L10 6z"
});

function SvgVn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZGUyOTEwO30uY2xzLTJ7ZmlsbDojZmZkZTAwO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEwIDYgMTEuMDQgOS4wOCAxNC41IDkuMDYgMTEuNjkgMTAuOTQgMTIuNzggMTQgMTAgMTIuMDggNy4yMiAxNCA4LjMxIDEwLjk0IDUuNSA5LjA2IDguOTYgOS4wOCAxMCA2Ii8+PC9zdmc+";
export { SvgVn as ReactComponent };